import { render, staticRenderFns } from "./EmprestimoForm.vue?vue&type=template&id=95e8d1f8"
import script from "./EmprestimoForm.vue?vue&type=script&lang=js"
export * from "./EmprestimoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports